import { AbstractTextContentVO } from "@goodgamestudios/localization";
import { getLogger } from "@goodgamestudios/logger";
import { IInternalGGSTextField } from "./IInternalGGSTextField";
import { FontConfigVO } from "../FontConfigVO";
import Container = createjs.Container;
import Rectangle = createjs.Rectangle;
const logger = getLogger("GGSTextFieldTLFStrategy");

export class GGSTextFieldTLFStrategy {
    public static readonly NAME = "GGSTextFieldTLFStrategy";

    private _currentFontConfig: FontConfigVO;
    private _container: Container;

    constructor(textField: IInternalGGSTextField) {
        logger.warn("GGSTextFieldTLFStrategy is not implemented");
    }
    public displayText(textContent: string, textContentVO: AbstractTextContentVO = null): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }

    public applyFontConfiguration(config: FontConfigVO): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public activate(): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public deactivate(): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public get currentFontConfig(): FontConfigVO {
        return this._currentFontConfig;
    }
    /**
     * Copy changeable properties if there is a config already defined
     * @param config
     */
    public set currentFontConfig(config: FontConfigVO){
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
        this._currentFontConfig = config;
    }
    public setFocus(): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public updateTabIndex(index: number): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public updateTabEnabled(flag: boolean): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    /**
     * Does nothing in TLF strategy, because of:
     * - static texts will be cut already by GoodgameTextField.displayText()
     * - typed in texts by the user are cut in onFlowOperationEndEvent()
     *   by retrieving the maxChars value directly from the model
     *
     * There's no property that have to be set like TextField.maxChars here.
     *
     * @param value
     */
    public updateMaxChars(value: number): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    /**
     * After initialization of the tlf text field, visible-property of basic TF
     * switches to "false", but standard text field stays in the movie clip.
     * We need to change its x/y coordinates and width/height, too.
     */
    public updateX(value: number): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public updateY(value: number): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public updateWidth(value: number): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public updateHeight(value: number): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public updateScaleX(value: number): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public updateScaleY(value: number): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public updateScrollV(value: number): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public updateRotation(value: number): void {
        this._container.rotation = value;
    }
    public updateBackground(value: boolean): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public updateBackgroundColor(value: number): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public get maxScrollV(): number {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
        return 0;
    }
    public get scrollV(): number {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
        return 0;
    }
    public updateIndent(value: number): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    // TODO: Complete disposing
    public dispose(): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    // TODO
    public updateDisplayAsPassword(value: boolean): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    // TODO
    /**
     * Indicates if the input TextField displays still the default text content.
     *
     * @return
     */
    public get containsDefaultTextContent(): boolean {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
        return false;
    }
    public updateMultiline(value: boolean): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public updateWordwrap(value: boolean): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public get textWidth(): number {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
        return 0;
    }
    public get textHeight(): number {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
        return 0;
    }
    // TODO: low priority
    public get caretIndex(): number {
        return 0;
    }
    public updateMouseEnabled(value: boolean): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public setSelection(beginIndex: number, endIndex: number): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public updateSelectable(value: boolean): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public updateType(type: string): void {
        // 			logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public updateSize(value: Object): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public updateColor(color: Object): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    /**
     * Expects a constant of GGSVerticalAlign (copied from TLF's VerticalAlign)
     * @param direction
     */
    public updateVerticalAlign(direction: string): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public updateTextAlign(direction: string): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public addEventListenerForEventType(type: string): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public removeEventListenerForEventType(type: string): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public hasEventListenerForEventType(type: string): boolean {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
        return false;
    }
    public updateVisible(value: boolean): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public updateRestrict(value: string): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public set autoSize(value: string) {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public fitTextSizeToBounds(bounds: Rectangle = null): void {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public get numLines(): number {
        // TODO: implement
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
        return 0;
    }
    public updateAutoFitToBounds(value: boolean): void {
        // TODO: implement
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public set autoFitToBounds(value: boolean) {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
    }
    public get autoFitToBounds(): boolean {
        logger.warn("GGSTextFieldTLFStrategy.displayText is not implemented");
        return false;
    }
}
